import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FullKit from "./sections/FullKit";
import Catalog from "./sections/Catalog";
import Ritual from "./sections/Ritual";
import Ingredients from "./sections/Ingredients";
import Reviews from "./sections/Reviews";
import Community from "./sections/Community";
import Faq from "./sections/Faq";
import Shipping from "./sections/Shipping";
import Whatsapp from "./sections/Whatsapp";
import Footer from "@/reusable_sections/Footer";
import MobileStickyBar from "./sections/MobileStickyBar";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FullKit />
      <Catalog />
      <Ritual />
      <Ingredients />
      <Reviews />
      <Community />
      <Faq />
      <Shipping />
      <Whatsapp />
      <Footer />
      <MobileStickyBar />
    </div>;
}